export const EXPENSE_CATEGORIES = [
  'Office Rent',
  'Furniture',
  'Electronics',
  'Software/Tools',
  'Marketing',
  'Utilities',
  'Internet/Phone',
  'Food/Refreshments',
  'Travel',
  'Legal/Professional',
  'Salaries',
  'Other'
];

export const BANKS = [
  { id: 'alfalah', name: 'Bank Alfalah (Personal)' },
  { id: 'meezan', name: 'Meezan Bank (Business)' },
  { id: 'payoneer', name: 'Payoneer (GBP)' }
];

export const TRANSFER_TYPES = [
  { id: 'p2b', label: 'Personal → Business' },
  { id: 'b2p', label: 'Business → Personal' }
];